module.exports = __webpack_public_path__ + "img/CM.b4c9e39c.svg";